import svipBadage from "@/assets/images/svip_badage.png";
import { StaticImageData } from "next/image";

export enum DownloadImgType {
  jpg = "jpg",
  png = "png",
  ppt = "ppt",
  pdf = "pdf",
}

export const RICH_TEXT_MAX_LEN = 20000;

export const BTN_UUID = "create_ppt_submit";

export const FILE_TEXT_MAX_LEN = 30000;

export enum StepType {
  /**
   * 前置输入，一句话，导入文件，粘贴文本
   */
  write = 0,
  /**
   * 生成大纲
   */
  outline = 1,
  /**
   * 生成PPT
   */
  ppt = 2,
  /**
   * 选择模板
   */
  template = 3,
  /**
   * 分段分页
   */
  page = 4,
}

export enum TabKey {
  inAWord = "0",
  pasteText = "1",
  importFile = "2",
}

export const lenMap: {
  [key: string]: string;
} = {
  short: "1",
  medium: "2",
  long: "3",
};

export const generateMap: {
  [key: string]: string;
} = {
  retain: "2",
  simplify: "1",
  expand: "3",
};

export interface TabItem {
  key: TabKey;
  icon: string;
  title: string;
  tag?: StaticImageData;
}

export const TABS: TabItem[] = [
  {
    key: TabKey.inAWord,
    icon: "MagicWandBold",
    title: "一句话生成",
  },
  {
    key: TabKey.pasteText,
    icon: "TextSquareBold",
    title: "已有文本生成",
  },
  {
    key: TabKey.importFile,
    icon: "UploadFlowBold",
    title: "导入文件生成",
    tag: svipBadage,
  },
];

export enum FooterTabKey {
  record = "0",
  template = "1",
}

export interface FooterTabItem {
  key: FooterTabKey;
  title: string;
  forceLogin?: boolean;
}

export const FOOTER_TABS: FooterTabItem[] = [
  {
    key: FooterTabKey.record,
    title: "历史记录",
    forceLogin: true,
  },
  {
    key: FooterTabKey.template,
    title: "PPT模板",
  },
];

export const TRACK_MAP = {
  [TabKey.inAWord]: "one_sentence_subject",
  [TabKey.pasteText]: "text_subject",
  [TabKey.importFile]: "upload_file",
};

export const DOWNLOAD_SELECT = [
  {
    type: DownloadImgType.jpg,
    title: "JPG",
    message: "文件较小，不支持透明背景",
  },
  {
    type: DownloadImgType.png,
    title: "PNG",
    message: "无损图片，文件较大，不支持透明背景",
  },
  {
    type: DownloadImgType.ppt,
    title: "PPT",
    message: "文件较大，可编辑",
  },
  {
    type: DownloadImgType.pdf,
    title: "PDF",
    message: "比 PPT 文件大，不可编辑",
  },
];

// 申请记录的状态值
export enum PPTProcessStatus {
  // 不存在该记录
  noExist = 0,
  // 投递成功待处理
  pending = 1,
  // 处理进行中
  processing = 10,
  // 处理失败
  fail = 20,
  // 处理成功
  success = 30,
}

export const MESSAGE_KEY = "MESSAGE_KEY";

export interface PageItem {
  id: string;
  title?: string;
  sub_title?: string;
  type: string;
  content?: string;
}

export const MAX_PAGE_COUNT = 30;

export const MIN_PAGE_COUNT = 1;

export enum SdkModuleName {
  aippt = "aippt-sdk",
}

export enum Scene {
  AiPPT = "aippt",
}

export const SDK_PLATFORM: {
  [key: string]: string;
} = {
  "221": "roboneo",
};

export const MTCCDataScene = {
  aippt: "00119",
};

// 成本分摊埋点 https://cf.meitu.com/confluence/pages/viewpage.action?pageId=416230853
export const MTCCData: Record<
  string,
  {
    positionKey: string;
    function?: string;
    position: { [key: string]: string };
  }
> = {
  // 生成完整 PPT
  "/ppt/apply": {
    positionKey: "",
    function: MTCCDataScene["aippt"],
    position: {
      default: MTCCDataScene["aippt"],
    },
  },
};

export const TIP_TEXT = "您的内容已加密，生成后将自动删除";

/**
 * 上传文件需要会员的格式
 */
export const UPLOAD_FILE_MEMBER_FORMAT = ["txt", "pdf", "docx"];
